export const environment = {
  production: true,
  staging: true,
  apiUrl: 'https://api-frt.qoala-stg2.cotegg.com/',  // APIのベースURL - ビルド時に置換される
  liffLoginId: '2007273115-MjpdX1EX',     // LINEログイン用のLIFF ID - ビルド時に置換される
  lineCancelLiffId: '2007273115-eKrVz5kz'  // LINE連携解除用のLIFF ID - ビルド時に置換される
};

export const APP_KEY = 'XXXXXX';
// 環境ごとに調整
export const API_SERVER_URL = 'https://api-frt.qoala-stg2.cotegg.com/';
export const SERVICE_URL = 'https://qoala-stg2.cotegg.com/';
export const GA_TRACK_ID = 'UA-112028206-3';
export const FRONT_DOMAIN = 'cotegg.com'; // v1とv2のcookieを共有するため同じドメイン想定
export const V2_FRONT_URL = 'https://qoala-v2-stg-front.cotegg.com/'; 